import request from '@/config/axios'

export const getDealRoomPage = (params: any) =>
  request.get({ url: '/bosscircle/deal-room/page', params })
export const getDealRoom = (id: number) =>
  request.get({ url: '/bosscircle/deal-room/get', params: { id } })
export const updateDealRoomPaused = (data: any) =>
  request.put({ url: '/bosscircle/deal-room/paused', data })
